import { Link } from 'react-router-dom';
import '../assets/see-product.css';

function Contact(){
    return(
        <div className='container see-containte mb-5'>
            <div className='paragraphe'>
                <h1 className='titre text-center text-uppercase'>Nous Contacter</h1>
                <p className='info mt-1 pt-2'>
                Si vous avez des questions ou que vous souhaitez être conseillés, l'équipe Shoptacbd est à votre disposition.
                Si vous ne trouvez pas de réponse à vos questions dans notre FAQ, vous pouvez nous contacter directement via notre tchat ou par téléphone au +(33) 01 83 91 29 91.
                Aussi, si vous souhaitez mettre en place un plan d’accompagnement personnalisé, toute l’équipe
                Shoptacbd est à votre disposition sur contact@shoptacbd.com ou par téléphone au (+33) 01 83 91 29 91
                </p>
                <Link className='link text-center' to={"#"}>Nous contacter <img src={window.location.origin +"/images/fleche_green.svg"} alt="" /></Link>
            </div>
        </div>
    )
}

export default Contact;